import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SettingsPage from './components/SettingsPage/SettingsPage';
import { canAccessSettings, getCurrentUserRole } from './utils/permissions';
import reportWebVitals from './reportWebVitals';

// Импортируем блокировку консоли (применяется автоматически при загрузке модуля)
import './utils/consoleBlocker';

// ── Бесшовный перенос сессии со старого домена ──────────────────────────────
// Старая страница-заглушка («мы переехали») передаёт сюда действующий токен и
// объект пользователя через #-фрагмент. Секрет подписи токена общий со старым
// сервером, поэтому токен валиден — раскладываем его в localStorage ДО старта
// приложения, чтобы человек продолжил работу без повторного логина, и сразу
// стираем фрагмент из адресной строки (в т.ч. из истории).
(function importHandoffSession() {
    try {
        const hash = window.location.hash || '';
        if (!/[#&]auth=/.test(hash)) return;
        const params = new URLSearchParams(hash.replace(/^#/, ''));
        const token = params.get('auth');
        const user = params.get('user');
        if (token) {
            localStorage.setItem('authToken', token);
            if (user) {
                localStorage.setItem('currentUser', user);
                localStorage.setItem('isAuthenticated', 'true');
            }
        }
    } catch (_) { /* приватный режим и т.п. */ }
    try {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
    } catch (_) { /* noop */ }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));

// Проверяем путь для определения, какой компонент рендерить
const path = window.location.pathname;

if (path === '/settings' || path.startsWith('/settings/')) {
    // Проверяем права доступа к /settings
    getCurrentUserRole().then(role => {
        if (canAccessSettings(role)) {
            root.render(<SettingsPage />);
        } else {
            // Перенаправляем на главную страницу если нет доступа
            window.location.href = '/';
        }
    });
} else {
    root.render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
